import script from "./ConventionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ConventionComponent.vue?vue&type=script&setup=true&lang=js"

import "./ConventionComponent.vue?vue&type=style&index=0&id=1f52f3f8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f52f3f8"]])

export default __exports__